import * as React from 'react';
import { INewsItem, INewsListItem } from 'src/Entities/News/NewsItem';
import { fetchNewsDetails } from 'src/helpers/api';
import NewsModal from '.';
import SidebarContainer from './SidebarContainer';
import Content from './Content';

export interface INewsModalContainerProps {
  onCloseClick: () => void;
  initialSelectedItemId: number;
  initialListPage: number;
  showExpired?: boolean;
}

export interface INewsModalContainerState {
  status: 'idle' | 'loading' | 'loaded' | 'error';
  newsItem: null | INewsItem;
  activeItemId: number;
}

const NewsModalContainer = ({
  onCloseClick,
  initialSelectedItemId,
  initialListPage,
  showExpired
}: INewsModalContainerProps) => {
  const [state, setState] = React.useState<INewsModalContainerState>(() => {
    return {
      status: 'idle',
      newsItem: null,
      activeItemId: initialSelectedItemId,
    }
  });

  React.useEffect(() => {
    if (!state.activeItemId) {
      return;
    }

    setState({ ...state, status: 'loading' });

    const handleFetchSuccess = (newsItem: INewsItem) => {
      setState({ ...state, status: 'loaded', newsItem });
    };

    const handleFetchError = () => {
      setState({ ...state, status: 'error' });
    };

    fetchNewsDetails(state.activeItemId)
      .then(handleFetchSuccess)
      .catch(handleFetchError);
  }, [state.activeItemId]);

  const handleSidebarItemClick = (item: INewsListItem) => {
    if (item.id === state.activeItemId) {
      return;
    }

    setState({ ...state, activeItemId: item.id });
  };

  return (
    <NewsModal
      onCloseClick={onCloseClick}
      title={showExpired ? 'Nyhedsarkiv' : 'Nyheder'}
    >
      <SidebarContainer
        onItemClick={handleSidebarItemClick}
        activeNewsItemId={state.activeItemId}
        initialListPage={initialListPage}
        showExpired={showExpired}
      />
      {state.status !== 'idle' && (
        <Content
          status={state.status}
          item={state.newsItem ? state.newsItem : undefined}
        />
      )}
    </NewsModal>
  );
}
export default NewsModalContainer;



// WEBPACK FOOTER //
// ./src/components/News/NewsModal/NewsModalContainer.tsx